import axios from "axios";
import qs from "qs";

const baseURL = "https://api-enca.jetcrm.ru";
//const baseURL = "http://127.0.0.1:6443";
export const api_key = process.env.REACT_APP_API_KEY;
export const mall_id = process.env.REACT_APP_MALL_ID;
const defaultOptions = {
  api_key,
  mall_id,
};

const API_ROUTES = {
  VERIFY: "/user/login",
  SEND_CODE: "/user/registration",
  SEND_LETTER: "/enka/ny24/send",
};

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  },
});

export const UserApi = {
  async register(dto) {
    const { data } = await api.post(
      API_ROUTES.SEND_CODE,
      qs.stringify({ ...defaultOptions, ...dto })
    );

    return data;
  },

  async verify(dto) {
    const { data } = await api.post(
      API_ROUTES.VERIFY,
      qs.stringify({ ...defaultOptions, ...dto })
    );

    return data;
  },
};

export const LetterApi = {
  async sendMessage(dto) {
    const { data } = await api.post(API_ROUTES.SEND_LETTER, dto, {
      baseURL,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
};
